<template>
  <div class="auxiliary-header">
    <div class="header-left">
      <!-- 首页 -->
      <div class="header-item ellipsis title" @click="appIndex">
        {{
          userInfo.campus_name
            ? userInfo.campus_name
            : userInfo.company_name
            ? userInfo.company_name
            : systemName
        }}
      </div>
    </div>

    <div class="header-center"></div>

    <div class="header-right">
      <!-- 切换语言 -->
      <a-dropdown>
        <div class="header-item">Language</div>
        <a-menu
          slot="overlay"
          class="dropdown-wrap dropdown-language"
          @click="changeLanguage"
        >
          <a-menu-item key="zh_CN" :disabled="$i18n.locale === 'zh_CN'">
            中文
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item key="en" :disabled="$i18n.locale === 'en'">
            English
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['userInfo', 'systemName'])
  },

  methods: {
    // 首页
    appIndex() {
      this.$router.push({ name: 'login' })
    },

    // 切换语言
    changeLanguage(v) {
      if (v.key !== this.$i18n.locale) {
        this.$confirm({
          title: this.$t('public.switchLanguage'),
          content: '',
          onOk: () => {
            this.$store.commit('SET_LOCALELANGUAGE', v.key)
          },
          onCancel() {}
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.auxiliary-header {
  height: 100%;
  display: flex;
  justify-content: space-between;
  .header-left,
  .header-right {
    display: flex;
    /* 导航单例统一样式 */
    .header-item {
      background-color: @headerBackColor;
      padding: 0 20px;
      display: flex;
      align-items: center;
      color: @headerFontColor;
      cursor: pointer;
      .item-text {
        font-size: 16px;
      }
      &:hover {
        background-color: @headerActiveBackColor;
        /* .student {
          background-image: url('../../assets/img/pageHeader/student.png');
        } */
      }
      .header-item--icon {
        width: @iconWidth;
        height: @iconHeight;
        margin-right: 12px;
        background-size: cover;
      }
      /* .student {
        background-image: url('../../assets/img/pageHeader/student_active.png');
      } */
    }
  }
  .header-left {
    .title {
      padding: 0 24px;
      font-size: 16px;
    }
  }
  .header-right {
    justify-content: flex-end;
  }
  .header-center {
    flex-grow: 1;
    background-color: @themeColor;
  }
}
</style>
